import { MenuCategory, MenuFilters, MenuItem } from '@lunit/shared-types';
import { api } from './client';

export async function getMenuCategories(venueId: string): Promise<MenuCategory[]> {
  return api.get<MenuCategory[]>(`/menu/categories?venueId=${venueId}`);
}

export async function getMenuItems(
  venueId: string,
  filters?: MenuFilters
): Promise<MenuItem[]> {
  const params = new URLSearchParams({ venueId });

  if (filters?.categoryId) params.append('categoryId', filters.categoryId);
  if (filters?.search) params.append('search', filters.search);
  if (filters?.isFeatured !== undefined)
    params.append('isFeatured', String(filters.isFeatured));
  if (filters?.isAvailable !== undefined)
    params.append('isAvailable', String(filters.isAvailable));

  return api.get<MenuItem[]>(`/menu/items?${params.toString()}`);
}

export async function getMenuItem(id: string): Promise<MenuItem> {
  return api.get<MenuItem>(`/menu/items/${id}`);
}

export interface PublicMenu {
  categories: MenuCategory[];
  items: MenuItem[];
}

/**
 * Get published menu for Mini App (public endpoint)
 * Returns menu only if owner has published it
 */
export async function getPublicMenu(venueId: string): Promise<PublicMenu> {
  return api.get<PublicMenu>(`/menu/public?venueId=${encodeURIComponent(venueId)}`);
}

